import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  selectedStatus: null,
  searchText: null,
  empresa: null,
  centroCusto: [],
  produto: [],
  projeto: [],
  responsavel: [],
  fornecedor: [],
  dataFinal: null,
  dataInicial: null,
  grupo: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
